OT.createNS('OT.Redesign.Views.Filters.Sort');

OT.Redesign.Views.Filters.Sort = Backbone.ViewManager.BaseView.extend({
    el: '#sort-dropdown__container',
    template: 'Redesign/Filters/_PopupMenuFilter',
    events: {
        'click button': 'toggle',
        'keydown button': 'handleMenuButtonKeydown',
        'keydown .sort-dropdown__option_button': 'handleOptionButtonsKeydown',
        'click .sort-dropdown__option_button': 'sort',
    },
    initialize: function() {
        this.keyCode = Object.freeze({
            'RETURN': 13,
            'SPACE': 32,
            'ESC': 27,
            'PAGEUP': 33,
            'PAGEDOWN': 34,
            'END': 35,
            'HOME': 36,
            'UP': 38,
            'DOWN': 40
          });
        this.toggle = this.toggle.bind(this);
        this.sort = this.sort.bind(this);
        this.hideDropDown = this.hideDropDown.bind(this);
        this.showDropDown = this.showDropDown.bind(this);
        this.focusToFirstItem = this.focusToFirstItem.bind(this);
        this.setFocusToPreviousItem = this.setFocusToPreviousItem.bind(this);
        this.setFocusToNextItem = this.setFocusToNextItem.bind(this);
        this.isMenuBoxOpen = false;
        this.openDorpdownButton = this.$el.find('.sort-dropdown__button');
        this.sortDropdownBox = this.$el.find('.sort-dropdown__options');
        this.sortDropdownButtons = this.$el.find('.sort-dropdown__option_button')
        this.dropDownIcon = this.$el.find('.dropdown__icon');
        this.request = OTSearchData.Request;
        this.firstMenuItem = this.sortDropdownButtons[0];
        this.lastMenuItem = this.sortDropdownButtons[this.sortDropdownButtons.length -1];
        $('body').on('click', function(e) {
            var dropdownElem = document.getElementById('sort-dropdown__container'),
            targetElement = e.target;    
            if(dropdownElem && !dropdownElem.contains(targetElement)) {
                this.isMenuBoxOpen = false;
                this.hideDropDown();
            }   
        }.bind(this));
    },
    sort: function (e) {
        var target = $( e.target );
        if(this.request.SortString !== target.val()) {
            this.sortDropdownButtons.removeClass('highlight')
            target.addClass('highlight')
            OTSearchBundle.changeSort(target.val());
        }
    },
    toggle: function () {
        this.isMenuBoxOpen = !this.isMenuBoxOpen;
        if(this.isMenuBoxOpen) {
            this.openDorpdownButton.attr("aria-expanded","true");
            this.showDropDown();
        } else {
            this.openDorpdownButton.attr("aria-expanded","false");
            this.hideDropDown();
        }
    },
    hideDropDown: function() {
        this.sortDropdownBox.hide();
        this.dropDownIcon.addClass('arrow_down')
        this.dropDownIcon.removeClass('arrow_up')
    },
    showDropDown: function() {
        this.sortDropdownBox.show();
        this.dropDownIcon.addClass('arrow_up')
        this.dropDownIcon.removeClass('arrow_down')
    },
    handleMenuButtonKeydown: function(e) {
        switch (e.keyCode) {
            case this.keyCode.SPACE:
            case this.keyCode.RETURN:
            case this.keyCode.DOWN:
              this.showDropDown();
              this.focusToFirstItem();
              break;
            case this.keyCode.UP:
               this.showDropDown();
               this.focusToLastItem();
              break;
            case this.keyCode.ESC:
               this.hideDropDown();
               break;
          }
    },
    handleOptionButtonsKeydown: function(e) {
        switch (e.keyCode) {
            case this.keyCode.ESC:
              this.openDorpdownButton.focus();
              break;
      
            case this.keyCode.UP:
              this.setFocusToPreviousItem(e.target);
              break;
      
            case this.keyCode.DOWN:
              this.setFocusToNextItem(e.target);
              break;     
            case this.keyCode.HOME:
            case this.keyCode.PAGEUP:
              this.focusToFirstItem();
              break;
            case this.keyCode.END:
            case this.keyCode.PAGEDOWN:
              this.focusToLastItem();
              break;
            case this.keyCode.SPACE:
            case this.keyCode.RETURN:
                e.target.click();
                this.hideDropDown();
              break;                               
        }
    },
    setFocusToPreviousItem: function (currentItem) {      
        if (currentItem === this.firstMenuItem) {
          this.lastMenuItem.focus();
        }
        else {
            var nodes =  Array.prototype.slice.call(this.sortDropdownButtons)
            var index = nodes.indexOf(currentItem);
            this.sortDropdownButtons[index - 1].focus();
        }
    },
    setFocusToNextItem: function (currentItem) {      
        if (currentItem === this.lastMenuItem) {
          this.firstMenuItem.focus();
        }
        else {
            var nodes =  Array.prototype.slice.call(this.sortDropdownButtons)
            var index = nodes.indexOf(currentItem);
            this.sortDropdownButtons[index + 1].focus();
        }
    },
    focusToFirstItem: function() {  
        this.firstMenuItem.focus();
    },
    focusToLastItem: function() {
        this.lastMenuItem.focus();
    },
    beforeRender: function () {
        this.additionalData = {
            request: OTSearchData.Request,
        };
        return this;
    },
});
